export default function checkValidParams({ to, next }) {
    const isParamsValid = !Object.keys(to.params).find(paramName => !/^[A-Za-z\d-_]*$/.test(to.params[paramName]))

    if (!isParamsValid) {
        console.error('One or more route params are invalid')
        return next({ name: '404' })
    }
    
    return next()
}